import { useLayoutEffect, useRef } from "react";
import Experience from "../../Experience/Experience";
import "./AppDevelopmentExperience.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function AppDevelopmentExperience() {
  const rootRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(".app-head .eyebrow", {
        y: 20, opacity: 0, duration: 0.6, ease: "power3.out",
        scrollTrigger: { trigger: ".app-head", start: "top 88%" },
      });
      gsap.from(".app-head h2", {
        y: 40, opacity: 0, duration: 0.8, ease: "power3.out",
        scrollTrigger: { trigger: ".app-head", start: "top 85%" },
      });
      gsap.from(".app-head p", {
        y: 20, opacity: 0, duration: 0.6, delay: 0.1, ease: "power3.out",
        scrollTrigger: { trigger: ".app-head", start: "top 85%" },
      });
      gsap.from(".app-grid .experience-card", {
        y: 40, opacity: 0, duration: 0.7, stagger: 0.12, ease: "power3.out",
        scrollTrigger: { trigger: ".app-grid", start: "top 88%" },
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="skills-section app-section">
      <div className="skills-inner">
        <div className="app-head skills-head">
          <span className="eyebrow">03 — Mobile</span>
          <h2>
            App <span className="grad-text">Development</span>
          </h2>
          <p>Native-feel cross-platform apps — smooth, offline-ready, production polished.</p>
        </div>
        <div className="app-grid skills-grid">
          <Experience name="React Native" level="Intermediate" image="react-native-logo.png" />
          <Experience name="Flutter" level="Intermediate" image="flutter-original.svg" />
        </div>
      </div>
    </section>
  );
}
